<template>
    <nav id="menu">
        <ul>
            <!-- Dashboard -->
            <li class="d-flex flex-row justify-content-between align-items-center mt-3 mb-0" style="height: 3vh; max-height: 3vh">
                <router-link :to="{ name: 'dashboard' }" class="d-flex flex-row justify-content-start align-items-center gap-2">
                    <i class="bi bi-columns-gap w-auto mb-auto mt-auto fs-5"></i>
                    <strong class="fs-5 m-auto">Dashboard</strong>
                </router-link>
            </li>

            <!-- Scegli partite -->
            <li class="d-flex flex-row justify-content-between align-items-center mt-3 mb-0" style="height: 3vh; max-height: 3vh" @click="toggleDropdown('scegli_partite')">
                <div 
                    class="d-flex flex-row justify-content-start align-items-center gap-2"
                >
                    <font-awesome-icon class="mb-auto mt-auto fs-5" icon="futbol" style="color: #D3B100"/>
                    <strong class="fs-5 m-auto">Scegli Partite</strong>
                </div>
                <i 
                    class="bi mb-auto mt-auto fs-4" 
                    :class="{'bi-chevron-up': isDropdownVisible('scegli_partite'), 'bi-chevron-down': !isDropdownVisible('scegli_partite')}"
                    style="color: white"
                ></i>
            </li>

            <!-- Lista "Scegli partite" -->
            <div>
                <ul v-if="isDropdownVisible('scegli_partite')" style="list-style: none;">
                    <li class="mb-2">
                        <router-link class="text-decoration-none" :to="{name: 'event.index'}">
                            <p style="margin-block-end: 0; font-size: 14px;">Scelta ZikiPro</p>
                        </router-link>
                    </li>
                    <li class="mb-2">
                        <router-link class="text-decoration-none" :to="{name: 'event.classic'}">
                            <p style="margin-block-end: 0; font-size: 14px;">Scelta classica</p>
                        </router-link>
                    </li>
                </ul>
            </div>

            <!-- La sfida -->
            <li class="d-flex flex-row justify-content-between align-items-center mt-3 mb-0" style="height: 3vh; max-height: 3vh" @click="toggleDropdown('la_sfida')">
                <div class="d-flex flex-row justify-content-start align-items-center gap-2">
                    <i class="w-auto bi bi-trophy mb-auto mt-auto fs-5"></i>
                    <strong class="fs-5 m-auto">La sfida</strong>
                </div>
                <i 
                    class="bi mb-auto mt-auto fs-4" 
                    :class="{'bi-chevron-up': isDropdownVisible('la_sfida'), 'bi-chevron-down': !isDropdownVisible('scegli_partite')}"
                    style="color: white"
                ></i>
            </li>

            <!-- Lista "La sfida" -->
            <div>
                <ul v-if="isDropdownVisible('la_sfida')" style="list-style: none;">
                    <li class="mb-2">
                        <router-link class="text-decoration-none" :to="{name: 'challenge.list'}">
                            <p style="margin-block-end: 0; font-size: 14px;">Lista sfide</p>
                        </router-link>
                    </li>
                    <li class="mb-2">
                        <router-link class="text-decoration-none" :to="{name: 'challenge.ranking'}">
                            <p style="margin-block-end: 0; font-size: 14px;">Classifiche sfide</p>
                        </router-link>
                    </li>
                    <li class="mb-2">
                        <router-link class="text-decoration-none" :to="{name: 'challenge.howto'}">
                            <p style="margin-block-end: 0; font-size: 14px;">Come si guadagna</p>
                        </router-link>
                    </li>
                </ul>
            </div>

            <!-- Archivio giocate -->
            <li class="d-flex flex-row justify-content-between align-items-center mt-3 mb-0" style="height: 3vh; max-height: 3vh">
                <router-link :to="{name: 'bill.index'}" class="d-flex flex-row justify-content-start align-items-center gap-2">
                    <i class="bi bi-archive w-auto mb-auto mt-auto fs-5"></i>
                    <strong class="fs-5 m-auto">Archivio giocate</strong>
                </router-link>
            </li>
            
            <!-- Salva errori -->
            <li class="d-flex flex-row justify-content-between align-items-center mt-3 mb-0" style="height: 3vh; max-height: 3vh">
                <router-link :to="{name: 'system.index'}" class="d-flex flex-row justify-content-start align-items-center gap-2">
                    <i class="bi bi-shield-check w-auto mb-auto mt-auto fs-5"></i>
                    <strong class="fs-5 m-auto">Salva errori</strong>
                </router-link>
            </li>

            <!-- Blocco note -->
            <li class="d-flex flex-row justify-content-between align-items-center mt-3 mb-0" style="height: 3vh; max-height: 3vh">
                <router-link :to="{name: 'bookmark.index'}" class="d-flex flex-row justify-content-start align-items-center gap-2">
                    <i class="bi bi-pencil-square w-auto mb-auto mt-auto fs-5"></i>
                    <strong class="fs-5 m-auto">Blocco note</strong>
                </router-link>
            </li>

            <!-- Pronostici -->
            <li class="d-flex flex-row justify-content-between align-items-center mt-3 mb-0" style="height: 3vh; max-height: 3vh">
                <router-link :to="{name: 'score.index'}" class="d-flex flex-row justify-content-start align-items-center gap-2">
                    <i class="w-auto bi bi-graph-up-arrow mb-auto mt-auto fs-5"></i>
                    <strong class="fs-5 m-auto">Pronostici</strong>
                </router-link>
            </li>        

            <!-- Community -->
            <li class="d-flex flex-row justify-content-between align-items-center mt-3 mb-0" style="height: 3vh; max-height: 3vh" @click="toggleDropdown('community')">
                <div class="d-flex flex-row justify-content-start align-items-center gap-2">
                    <i class="w-auto bi bi-people-fill mb-auto mt-auto fs-5"></i>
                    <strong class="fs-5 m-auto">Community</strong>
                </div>
                <i 
                    class="bi mb-auto mt-auto fs-4" 
                    :class="{'bi-chevron-up': isDropdownVisible('scegli_partite'), 'bi-chevron-down': !isDropdownVisible('scegli_partite')}"
                    style="color: white"
                ></i>
            </li>

            <!-- Lista "Community" -->
            <div>
                <ul v-if="isDropdownVisible('community')" style="list-style: none;">
                    <li class="mb-2">
                        <router-link class="text-decoration-none" :to="{name: 'community.search'}">
                            <p style="margin-block-end: 0; font-size: 14px;">Cerca amici</p>
                        </router-link>
                    </li>
                    <li class="mb-2">
                        <router-link class="text-decoration-none" :to="{name: 'community.friends'}">
                            <p style="margin-block-end: 0; font-size: 14px;">I miei amici</p>
                        </router-link>
                    </li>
                    <li class="mb-2">
                        <router-link class="text-decoration-none" :to="{name: 'community.bills'}">
                            <p style="margin-block-end: 0; font-size: 14px;">Le giocate degli amici</p>
                        </router-link>
                    </li>
                    <li class="mb-2">
                        <router-link class="text-decoration-none" :to="{name: 'message.index'}">
                            <p style="margin-block-end: 0; font-size: 14px;">Messaggi</p>
                        </router-link>
                    </li>
                </ul>
            </div>

            <!-- Gruppi -->
            <li class="d-flex flex-row justify-content-between align-items-center mt-3 mb-0" style="height: 3vh; max-height: 3vh" @click="toggleDropdown('gruppi')">
                <div class="d-flex flex-row justify-content-start align-items-center gap-2">
                    <font-awesome-icon class="mb-auto mt-auto fs-5" icon="users" style="color: #D3B100"/>
                    <strong class="fs-5 m-auto">Gruppi</strong>
                </div>
                <i 
                    class="bi mb-auto mt-auto fs-4" 
                    :class="{'bi-chevron-up': isDropdownVisible('scegli_partite'), 'bi-chevron-down': !isDropdownVisible('scegli_partite')}"
                    style="color: white"
                ></i>
            </li>

            <!-- Lista "Gruppi" -->
            <div>
                <ul v-if="isDropdownVisible('gruppi')" style="list-style: none;">
                    <li class="mb-2">
                        <router-link class="text-decoration-none" :to="{name: 'group.index.me'}">
                            <p style="margin-block-end: 0; font-size: 14px;">I miei gruppi</p>
                        </router-link>
                    </li>
                    <li class="mb-2">
                        <router-link class="text-decoration-none" :to="{name: 'group.index'}">
                            <p style="margin-block-end: 0; font-size: 14px;">Elenco gruppi</p>
                        </router-link>
                    </li>
                    <li class="mb-2">
                        <router-link class="text-decoration-none" :to="{name: 'group.create'}">
                            <p style="margin-block-end: 0; font-size: 14px;">Crea gruppo</p>
                        </router-link>
                    </li>
                </ul>
            </div>

            <!-- Profilo -->
            <li class="d-flex flex-row justify-content-between align-items-center mt-3 mb-0" style="height: 3vh; max-height: 3vh">
                <router-link :to="{name: 'user.profile'}" class="d-flex flex-row justify-content-start align-items-center gap-2">
                    <i class="bi bi-person w-auto mb-auto mt-auto fs-5"></i>
                    <strong class="fs-5 m-auto">Profilo</strong>
                </router-link>
            </li>
        </ul>

        <div v-if="$store.getters.usergroup == 'admin'">
            <hr>

            <button @click="goToAdmin" class="btn btn-outline-primary w-100">
                Area di amministrazione
            </button>
        </div>

    </nav>
</template>

<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

export default {
    name: 'LayoutsPartsSidebar',

	components: {
		FontAwesomeIcon,
	},

    data() {
        return {
            dropdowns: {
                scegli_partite: false,
                la_sfida: false,
                pronostici: false,
                community: false,
                gruppi: false,
            },
        };
    },

    methods: {
        toggleDropdown(name) {
            this.$set(this.dropdowns, name, !this.dropdowns[name]);
        },
        isDropdownVisible(name) {
            return this.dropdowns[name] || false;
        },
        goToAdmin() {
            if (this.$route.name !== 'admin.dashboard') {
                this.$router.push({ name: 'admin.dashboard' }).then(() => {
                    window.location.reload();
                });
            }
        },
        closeSidebar() {
            // Chiudi l'offcanvas della sidebar
            const sidebarElement = document.getElementById('sidebar')
            if (sidebarElement) {
                const sidebar = bootstrap.Offcanvas.getInstance(sidebarElement)
                if (sidebar) {
                    sidebar.hide()
                }
            }
        }
    },
    watch: {
        '$route'() {
            // Chiudi tutti i dropdown quando cambia route
            Object.keys(this.dropdowns).forEach(key => {
                this.dropdowns[key] = false
            })
            // Chiudi la sidebar su mobile
            this.closeSidebar()
        }
    },

    computed: {
        menu(){
            return _.filter(this.$store.state.menu, 'submenu');
        }
    }
}
</script>